/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ForceChangePasswordRouteImport } from './routes/force-change-password'
import { Route as AnnexRouteImport } from './routes/annex'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthUsersRouteImport } from './routes/_auth.users'
import { Route as AuthProfileRouteImport } from './routes/_auth.profile'
import { Route as AuthParametersRouteImport } from './routes/_auth.parameters'
import { Route as AuthDocumentsRouteImport } from './routes/_auth.documents'
import { Route as AuthCreateRouteImport } from './routes/_auth.create'
import { Route as PrintBookIdNodeIdRouteImport } from './routes/print.$bookId.$nodeId'
import { Route as AuthDocumentDocumentIdRouteImport } from './routes/_auth.document.$documentId'
import { Route as AuthDocumentDocIdReferencesReviewRouteImport } from './routes/_auth.document.$docId.references-review'
import { Route as AuthDocumentDocIdNodeIdRouteImport } from './routes/_auth.document.$docId.$nodeId'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ForceChangePasswordRoute = ForceChangePasswordRouteImport.update({
  id: '/force-change-password',
  path: '/force-change-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AnnexRoute = AnnexRouteImport.update({
  id: '/annex',
  path: '/annex',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthUsersRoute = AuthUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthParametersRoute = AuthParametersRouteImport.update({
  id: '/parameters',
  path: '/parameters',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentsRoute = AuthDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => AuthRoute,
} as any)
const AuthCreateRoute = AuthCreateRouteImport.update({
  id: '/create',
  path: '/create',
  getParentRoute: () => AuthRoute,
} as any)
const PrintBookIdNodeIdRoute = PrintBookIdNodeIdRouteImport.update({
  id: '/print/$bookId/$nodeId',
  path: '/print/$bookId/$nodeId',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthDocumentDocumentIdRoute = AuthDocumentDocumentIdRouteImport.update({
  id: '/document/$documentId',
  path: '/document/$documentId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthDocumentDocIdReferencesReviewRoute =
  AuthDocumentDocIdReferencesReviewRouteImport.update({
    id: '/document/$docId/references-review',
    path: '/document/$docId/references-review',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthDocumentDocIdNodeIdRoute = AuthDocumentDocIdNodeIdRouteImport.update({
  id: '/document/$docId/$nodeId',
  path: '/document/$docId/$nodeId',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/annex': typeof AnnexRoute
  '/force-change-password': typeof ForceChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/create': typeof AuthCreateRoute
  '/documents': typeof AuthDocumentsRoute
  '/parameters': typeof AuthParametersRoute
  '/profile': typeof AuthProfileRoute
  '/users': typeof AuthUsersRoute
  '/document/$documentId': typeof AuthDocumentDocumentIdRoute
  '/print/$bookId/$nodeId': typeof PrintBookIdNodeIdRoute
  '/document/$docId/$nodeId': typeof AuthDocumentDocIdNodeIdRoute
  '/document/$docId/references-review': typeof AuthDocumentDocIdReferencesReviewRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/annex': typeof AnnexRoute
  '/force-change-password': typeof ForceChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/create': typeof AuthCreateRoute
  '/documents': typeof AuthDocumentsRoute
  '/parameters': typeof AuthParametersRoute
  '/profile': typeof AuthProfileRoute
  '/users': typeof AuthUsersRoute
  '/document/$documentId': typeof AuthDocumentDocumentIdRoute
  '/print/$bookId/$nodeId': typeof PrintBookIdNodeIdRoute
  '/document/$docId/$nodeId': typeof AuthDocumentDocIdNodeIdRoute
  '/document/$docId/references-review': typeof AuthDocumentDocIdReferencesReviewRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_auth': typeof AuthRouteWithChildren
  '/annex': typeof AnnexRoute
  '/force-change-password': typeof ForceChangePasswordRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/create': typeof AuthCreateRoute
  '/_auth/documents': typeof AuthDocumentsRoute
  '/_auth/parameters': typeof AuthParametersRoute
  '/_auth/profile': typeof AuthProfileRoute
  '/_auth/users': typeof AuthUsersRoute
  '/_auth/document/$documentId': typeof AuthDocumentDocumentIdRoute
  '/print/$bookId/$nodeId': typeof PrintBookIdNodeIdRoute
  '/_auth/document/$docId/$nodeId': typeof AuthDocumentDocIdNodeIdRoute
  '/_auth/document/$docId/references-review': typeof AuthDocumentDocIdReferencesReviewRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/annex'
    | '/force-change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/create'
    | '/documents'
    | '/parameters'
    | '/profile'
    | '/users'
    | '/document/$documentId'
    | '/print/$bookId/$nodeId'
    | '/document/$docId/$nodeId'
    | '/document/$docId/references-review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/annex'
    | '/force-change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/create'
    | '/documents'
    | '/parameters'
    | '/profile'
    | '/users'
    | '/document/$documentId'
    | '/print/$bookId/$nodeId'
    | '/document/$docId/$nodeId'
    | '/document/$docId/references-review'
  id:
    | '__root__'
    | '/'
    | '/_auth'
    | '/annex'
    | '/force-change-password'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_auth/create'
    | '/_auth/documents'
    | '/_auth/parameters'
    | '/_auth/profile'
    | '/_auth/users'
    | '/_auth/document/$documentId'
    | '/print/$bookId/$nodeId'
    | '/_auth/document/$docId/$nodeId'
    | '/_auth/document/$docId/references-review'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthRoute: typeof AuthRouteWithChildren
  AnnexRoute: typeof AnnexRoute
  ForceChangePasswordRoute: typeof ForceChangePasswordRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  PrintBookIdNodeIdRoute: typeof PrintBookIdNodeIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/force-change-password': {
      id: '/force-change-password'
      path: '/force-change-password'
      fullPath: '/force-change-password'
      preLoaderRoute: typeof ForceChangePasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/annex': {
      id: '/annex'
      path: '/annex'
      fullPath: '/annex'
      preLoaderRoute: typeof AnnexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/users': {
      id: '/_auth/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthUsersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/parameters': {
      id: '/_auth/parameters'
      path: '/parameters'
      fullPath: '/parameters'
      preLoaderRoute: typeof AuthParametersRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/documents': {
      id: '/_auth/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof AuthDocumentsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/create': {
      id: '/_auth/create'
      path: '/create'
      fullPath: '/create'
      preLoaderRoute: typeof AuthCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/print/$bookId/$nodeId': {
      id: '/print/$bookId/$nodeId'
      path: '/print/$bookId/$nodeId'
      fullPath: '/print/$bookId/$nodeId'
      preLoaderRoute: typeof PrintBookIdNodeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/document/$documentId': {
      id: '/_auth/document/$documentId'
      path: '/document/$documentId'
      fullPath: '/document/$documentId'
      preLoaderRoute: typeof AuthDocumentDocumentIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/document/$docId/references-review': {
      id: '/_auth/document/$docId/references-review'
      path: '/document/$docId/references-review'
      fullPath: '/document/$docId/references-review'
      preLoaderRoute: typeof AuthDocumentDocIdReferencesReviewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/document/$docId/$nodeId': {
      id: '/_auth/document/$docId/$nodeId'
      path: '/document/$docId/$nodeId'
      fullPath: '/document/$docId/$nodeId'
      preLoaderRoute: typeof AuthDocumentDocIdNodeIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthCreateRoute: typeof AuthCreateRoute
  AuthDocumentsRoute: typeof AuthDocumentsRoute
  AuthParametersRoute: typeof AuthParametersRoute
  AuthProfileRoute: typeof AuthProfileRoute
  AuthUsersRoute: typeof AuthUsersRoute
  AuthDocumentDocumentIdRoute: typeof AuthDocumentDocumentIdRoute
  AuthDocumentDocIdNodeIdRoute: typeof AuthDocumentDocIdNodeIdRoute
  AuthDocumentDocIdReferencesReviewRoute: typeof AuthDocumentDocIdReferencesReviewRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthCreateRoute: AuthCreateRoute,
  AuthDocumentsRoute: AuthDocumentsRoute,
  AuthParametersRoute: AuthParametersRoute,
  AuthProfileRoute: AuthProfileRoute,
  AuthUsersRoute: AuthUsersRoute,
  AuthDocumentDocumentIdRoute: AuthDocumentDocumentIdRoute,
  AuthDocumentDocIdNodeIdRoute: AuthDocumentDocIdNodeIdRoute,
  AuthDocumentDocIdReferencesReviewRoute:
    AuthDocumentDocIdReferencesReviewRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthRoute: AuthRouteWithChildren,
  AnnexRoute: AnnexRoute,
  ForceChangePasswordRoute: ForceChangePasswordRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  PrintBookIdNodeIdRoute: PrintBookIdNodeIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
